import { useState } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

export default function ControlledAccordions ({ accordions, initialExpanded = {} }) {
  const { t } = useTranslation('raceGuide')
  const [expanded, setExpanded] = useState(initialExpanded)
  const [allExpanded, setAllExpanded] = useState(false)

  const keyFor = (title, accordionIndex, panelIndex) =>
    title?.id || `${accordionIndex}-${panelIndex}`

  const handleChange = (key) => (event, isExpanded) => {
    setExpanded(prev => ({
      ...prev,
      [key]: isExpanded
    }))
  }

  const toggleAll = () => {
    const newAllExpanded = !allExpanded
    setAllExpanded(newAllExpanded)

    const newExpanded = {}
    accordions.forEach((accordion, accordionIndex) => {
      accordion.titles.forEach((title, panelIndex) => {
        newExpanded[keyFor(title, accordionIndex, panelIndex)] = newAllExpanded
      })
    })
    setExpanded(newExpanded)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant='text'
          size='small'
          onClick={toggleAll}
          startIcon={
            <ExpandMoreIcon
              sx={{
              transform: allExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease'
            }}
            />
          }
        >
          {allExpanded ? t('raceGuide.collapseAll') : t('raceGuide.expandAll')}
        </Button>
      </Box>
      {accordions.map((accordion, accordionIndex) => (
        <Box key={`accordion-${accordionIndex}`}>
          {accordion.titles.map((title, panelIndex) => {
            const key = keyFor(title, accordionIndex, panelIndex)
            // Check if this panel should be expanded by default
            const childComponent = accordion.children[panelIndex]
            const shouldBeExpanded =
              childComponent?.type?.name === 'Sponsors' ||
              childComponent?.props?.opened ||
              expanded[key]

            return (
              <Accordion
                key={key}
                expanded={shouldBeExpanded || false}
                onChange={handleChange(key)}
                sx={{ boxShadow: 'none', position: 'unset', backgroundColor: 'transparent' }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${accordionIndex}-${panelIndex}-content`}
                  id={`panel${accordionIndex}-${panelIndex}-header`}
                  sx={{ backgroundColor: '#111' }}
                >
                  {title.icon && <Box sx={{ mr: 1 }}>{title.icon}</Box>}
                  <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                    {title.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                  width: '100%',
                  px: 1,
                  '@media (min-width: 600px)': {
                    width: 'auto',
                    px: 0
                  }
                }}
                >
                  {accordion.children[panelIndex]}
                </AccordionDetails>
              </Accordion>
            )
          })}
        </Box>
      ))}
    </Box>
  )
}
